import PropTypes from 'prop-types'
import Text from '@web-ui-kit/text'
import BasicButton from '@web-ui-kit/basic-button'
import * as Sc from './PageWrapper.style'
import { DEVICE_SIZE } from 'utils/constants'
import useMediaQuery from 'hooks/useMediaQuery'

const PageWrapper = ({ button, children, cancelButton, subtitle, title }) => {
  const isLarge = useMediaQuery(`(min-width: ${DEVICE_SIZE.TABLET})`)
  return (
    <Sc.Container>
      <Sc.TitleContainer>
        <Text variant={isLarge ? 'title3' : 'title3Mobile'}>{title}</Text>
        {subtitle && <Text variant='body'>{subtitle}</Text>}
      </Sc.TitleContainer>
      <Sc.Content $isText={typeof children === 'string'}>{children}</Sc.Content>
      <Sc.ButtonContainer>
        <BasicButton
          dataTestId={button?.dataTestId}
          disabled={button?.disabled}
          label={button.text}
          loading={button?.loading}
          onClick={button.onClick}
          size={isLarge ? 'big' : 'small'}
        />
        {cancelButton && (
          <BasicButton
            dataTestId={cancelButton?.dataTestId}
            label={cancelButton.text}
            onClick={cancelButton.onClick}
            size={isLarge ? 'big' : 'small'}
            variant='text'
          />
        )}
      </Sc.ButtonContainer>
    </Sc.Container>
  )
}

PageWrapper.defaultProps = {
  cancelButton: null,
  subtitle: null,
}

PageWrapper.propTypes = {
  button: PropTypes.shape({
    dataTestId: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
  cancelButton: PropTypes.shape({
    dataTestId: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
  }),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]).isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default PageWrapper
